const searchUsers = async (service, keyword) => {
  const res = await service.getAutoSuggestions(
    `/user/list?keyword=${encodeURIComponent(keyword)}`
  );
  return (res || []).map((user) => ({
    ...user,
    name: user.name || `${user.first_name || ""} ${user.last_name || ""}`.trim(),
  }));
};

const changePassword = async (service, email, password) => {
  return service.put("/user/change-password", {
    email,
    password,
  });
};

export { searchUsers, changePassword };
